import { EXPENSE_TYPE_CODES } from "../types/expenses";
import type { ExpenseImportTypeCode } from "../types/expenses-import.types";

export type ExpenseImportTemplate = {
	url: string;
	filename: string;
};

export function getExpenseImportTemplate(
	typeCode: ExpenseImportTypeCode | null
): ExpenseImportTemplate | null {
	if (!typeCode) {
		return null;
	}

	switch (typeCode) {
		case EXPENSE_TYPE_CODES.Infraction:
			return {
				url: new URL(
					"../assets/Fleeter_Despesas_Infração.xlsx",
					import.meta.url
				).href,
				filename: "Fleeter_Despesas_Infração.xlsx",
			};
		case EXPENSE_TYPE_CODES.Maintenance:
			return {
				url: new URL(
					"../assets/Fleeter_Despesas_Manutenção.xlsx",
					import.meta.url
				).href,
				filename: "Fleeter_Despesas_Manutenção.xlsx",
			};
		case EXPENSE_TYPE_CODES.Toll:
		case EXPENSE_TYPE_CODES.Trip:
		case EXPENSE_TYPE_CODES.Other:
			return {
				url: new URL("../assets/Fleeter_Despesas_Padrão.xlsx", import.meta.url)
					.href,
				filename: "Fleeter_Despesas_Padrão.xlsx",
			};
		case EXPENSE_TYPE_CODES.Reimbursement:
			return {
				url: new URL(
					"../assets/Fleeter_Despesas_Reembolso.xlsx",
					import.meta.url
				).href,
				filename: "Fleeter_Despesas_Reembolso.xlsx",
			};
		case EXPENSE_TYPE_CODES.Fuel:
			return {
				url: new URL(
					"../assets/Fleeter_Despesas_Combustível.xlsx",
					import.meta.url
				).href,
				filename: "Fleeter_Despesas_Combustível.xlsx",
			};
		default:
			return null;
	}
}

export function downloadExpenseImportTemplate(
	typeCode: ExpenseImportTypeCode | null
): boolean {
	const template = getExpenseImportTemplate(typeCode);
	if (!template) {
		return false;
	}

	// Evita quebra em cenários onde `document` não existe (ex: SSR).
	if (typeof document === "undefined") {
		return false;
	}

	const link = document.createElement("a");
	link.href = template.url;
	link.download = template.filename;
	link.click();

	return true;
}
